import React, { createContext, useState, useContext, useEffect } from 'react';
import { decryptData } from '../helpers/EncryptHelper';

const FinancialYearContext = createContext();

export const FinancialYearProvider = ({ children }) => {
  // Initialize financialYear state with an empty object
  const [financialYear, setFinancialYear] = useState({});
  //const [financialYear, setFinancialYear] = useState('2024-2025');

  // Load financialYear data from localStorage when component mounts
  useEffect(() => {
    const storedData = localStorage.getItem("current_fin_year");
    if (storedData) {
      const decryptedData = decryptData(storedData);
      if (decryptedData?._fin_year_id != null) {
        setFinancialYear(decryptedData._fin_year_id);
      }
      //setFinancialYear('2024-2025');
    }
  }, []); // Run effect only once on component mount

  return (
    <FinancialYearContext.Provider value={{ financialYear, setFinancialYear }}>
      {children}
    </FinancialYearContext.Provider>
  );
};

export const useFinancialYear = () => useContext(FinancialYearContext);
// export const useFinancialYear = () => {
//   const context = useContext(FinancialYearContext);
//   if (!context) {
//     throw new Error('useFinancialYear must be used within a FinancialYearProvider');
//   }
//   return context;
// };